import { render, staticRenderFns } from "./LoadingRoute.vue?vue&type=template&id=3fccd20d&scoped=true&"
import script from "./LoadingRoute.vue?vue&type=script&lang=js&"
export * from "./LoadingRoute.vue?vue&type=script&lang=js&"
import style0 from "./LoadingRoute.vue?vue&type=style&index=0&id=3fccd20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fccd20d",
  null
  
)

export default component.exports